<template>
  <v-toolbar card dense class="gradient_clair">
    Prog {{ number }} : {{ name }}
    <v-spacer></v-spacer>
    Pas : {{ pas }}
    <v-spacer></v-spacer>
    Temps : {{ totalHuman }} / {{ estimeHuman }}
  </v-toolbar>
</template>

<script>
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);
export default {
  data() {
    return {};
  },
  computed: {
    ovenData() {
      return this.$store.state.ovenData;
    },
    number() {
      return this.ovenData.recipeNumber;
    },
    name() {
      return this.ovenData.recipeName;
    },
    pas() {
      return this.ovenData.pas;
    },
    total() {
      return this.ovenData.total;
    },
    totalHuman() {
      if (this.total == "?") {
        return this.total;
      }
      return this.minutesToHumanHour(this.total);
    },
    estime() {
      return this.ovenData.estime;
    },
    estimeHuman() {
      if (this.estime == "?") {
        return this.estime;
      }
      return this.minutesToHumanHour(this.estime);
    }
  },
  methods: {
    minutesToHumanHour(value) {
      if (value == null) {
        return "";
      }
      if (value < 0) {
        return "";
      }

      var duration = moment.duration(Number(value), "minutes");
      return duration.format("hh:mm", { trim: false });
    }
  },

  mounted() {
    this.$store.dispatch("send", "recette");
  },
  watch: {}
};
</script>


<style>

</style>
